import { marker as T } from '@biesbjerg/ngx-translate-extract-marker';

export const helptextShell = {
  dialog_title: T('Copy and Paste'),

  copy_paste_message: T(
    'Context menu copy and paste operations \
    are disabled in the Shell. Copy and paste \
    shortcuts for Mac are <i>Command+c</i> and \
    <i>Command+v</i>. For most operating \
    systems, use <i>Ctrl+Insert</i> to copy and \
    <i>Shift+Insert</i> to paste.',
  ),

  podConsole: {
    nopod: {
      title: T('No Pods Found'),
      message: T('Invalid Pod name'),
    },
  },
};
